export const REQUEST_ENDPOINT =
  "https://hooks.zapier.com/hooks/catch/9615379/3zkrp18/";
